var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeaderLayout',{attrs:{"isBack":true}},[_c('div',{staticClass:"main-page-content"},[_c('CreateEditContent',{attrs:{"id":_vm.editId,"show-quick-create-action":!_vm.editId},on:{"confirm":_vm.handleConfirm}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }